// extracted by mini-css-extract-plugin
export default {"header":"HeadContainer_header__HLlK9"};